export default Object.freeze({
    NONE: 'NONE',
    BLE: 'BLE',
    RFID: 'RFID',
    BARCODE: 'BARCODE',
    MANUAL: 'MANUAL',
    ANY: 'ANY'
});
